export const PAGE_TYPES = {
  CHECKOUT: 'checkout',
  EVENT: 'event',
  FORM: 'form',
};
